import React from "react";
import {store} from '@redux/store';
import actions from '@redux/EditableTable/actions';
import TextArea from "antd/es/input/TextArea";

import moment from "moment";
import { US_REGIONS } from "@/constants/stateRegionMapping";
import FacilityLink from "@containers/management/Facility/FacilityLink";
import Select from "@components/ResponsiveSelect";

const {Option} = Select;

const company_items = store.getState().Auth.company;

export const FacilityProps = {
    title: 'Facility',
    name: 'facility',
    description: ''
}


export const FacilityColumnsCompact =() =>{
  return  [
        {
            title: 'key',
            dataIndex: 'id',
            key: 'id',
            editable: false,
            search: false,
            importIngore: true,
            hideInTable: true,
            width: '4%'
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            search: false,
            edit: true,
            sorter: (a, b) => a.name?.localeCompare(b.name),
            formItemProps: {
                rules: [
                    {
                        required: true,
                        message: 'required',
                    },
                ],
            },
            renderFormItem: () => <TextArea rows={1}/>,
            render: (text, record, _, action) => (
                <FacilityLink id={record.id} text={text} action={action} />
            )
        },
        {
            title: 'Category',
            dataIndex: 'category',
            key: 'category',
            edit: true,
            required: true,
            search: false,
            hideInTable: window.innerWidth < 760,
        },
        {
            title: 'Climate Zone',
            dataIndex: 'climate_zone',
            key: 'climate_zone',
            edit: true,
            required: false,
            search: false,
            hideInTable: window.innerWidth < 760,
            valueType: 'select',
            valueEnum: {
                '1': { text: '1' },
                '2': { text: '2' },
                '3': { text: '3' },
                '4': { text: '4' },
                '5': { text: '5' },
                '6': { text: '6' },
                '7': { text: '7' },
                '8': { text: '8' },
            },
        },
        {
            title: 'Region',
            dataIndex: 'region',
            key: 'region',
            edit: true,
            required: false,
            search: false,
            hideInTable: window.innerWidth < 760,
            valueType: 'select',
            valueEnum: {
                [US_REGIONS.PACIFIC]: { text: US_REGIONS.PACIFIC },
                [US_REGIONS.ROCKY_MOUNTAINS]: { text: US_REGIONS.ROCKY_MOUNTAINS },
                [US_REGIONS.SOUTHWEST]: { text: US_REGIONS.SOUTHWEST },
                [US_REGIONS.MIDWEST]: { text: US_REGIONS.MIDWEST },
                [US_REGIONS.SOUTHEAST]: { text: US_REGIONS.SOUTHEAST },
                [US_REGIONS.NORTHEAST]: { text: US_REGIONS.NORTHEAST },
                [US_REGIONS.NONCONTIGUOUS]: { text: US_REGIONS.NONCONTIGUOUS },
            },
        },
        {
            title: 'Address',
            dataIndex: 'address',
            key: 'address',
            edit: true,
            required: true,
            search: false,
            hideInTable: window.innerWidth < 760,
        },
        {
            title: 'Contact Name',
            dataIndex: 'contact_name',
            key: 'contact_name',
            edit: true,
            required: false,
            search: false,
            hideInTable: window.innerWidth < 760,
            renderFormItem: () => <TextArea rows={1}/>,
        },
        {
            title: 'Contact Email',
            dataIndex: 'contact_email',
            key: 'contact_email',
            edit: true,
            required: false,
            search: false,
            hideInTable: window.innerWidth < 760,
            renderFormItem: () => <TextArea rows={1}/>,
        },
        {
            title: 'Contact Phone',
            dataIndex: 'contact_phone',
            key: 'contact_phone',
            edit: true,
            required: false,
            search: false,
            hideInTable: window.innerWidth < 760,
            renderFormItem: () => <TextArea rows={1}/>,
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            edit: true,
            required: true,
            search: false,
            hideInTable: window.innerWidth < 760,
            renderFormItem: () => <TextArea rows={1}/>,
        },
        {
            title: 'Modified Date',
            dataIndex: 'modified_date',
            key: 'modified_date',
            editable: false,
            importIngore: true,
            hideInTable: window.innerWidth < 760,
            align: 'right', // 时间列右对齐
            sorter: (a, b) => a.modified_date - b.modified_date,
            render: (text, record) => (
                moment(record.modified_date).format('YYYY-MM-DD')
            )
        },
        {
            title: '',
            valueType: 'option',
            width: '6rem',
            importIngore: true,
            render: (text, record, _, action) => (
                <div className={'space-around'}>
                    <a
                        key="editable"
                        onClick={() => (action?.startEditable?.(record.id))}
                    >
                        <i className="fas fa-edit text-lg"></i>
                    </a>

                </div>
            ),
        },


    ];
}

